import { storage } from "./index";

import {
    getDownloadURL,
    ref,
    uploadBytesResumable,
    uploadBytes
} from 'firebase/storage'

const FILES_PATH = 'testing'

const fileRef = (path, id, filename) => {
    return ref(storage, `${FILES_PATH}/${path}/${id}/${filename}`)
}

export const getFileDownloadUrl = ref => {
    return getDownloadURL(ref)
}

export const uploadFileTask = (path, id, file, type) => {
    const uploadFileRef = fileRef(
        path,
        id,
        `${file.name}.${type}`
    )

    return uploadBytesResumable(uploadFileRef, file.blob, {
        contentType: type
    })
}

export const listenUploadImageProgress = (
    path,
    file,
    id,
    type,
    callback,
    error,
    success
) => {
    const uploadTask = uploadFileTask(path, id, file, type)

    uploadTask.on(
        'state_changed',
        snap => {
            const progress = Math.round(
                (snap.bytesTransferred / snap.totalBytes) * 100
            )
            callback(progress)
        },
        _error => {
            error(_error)
        },
        async () => {
            const url = await getFileDownloadUrl(uploadTask.snapshot.ref)
            success(url)
        }
    )
}

export const uploadImages = async (path, id, file) => {
    try {
        if (!file) {
            throw new Error("File is undefined or null.");
        }

        const upload = await uploadBytes(fileRef(path, id, `${file.name}`), file);
        let url = getDownloadURL(upload.ref);
        return url;
    } catch (error) {
        console.log(error, 'here');
        return '';
    }
}
